import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/form/button/Button';
import Modal, { ModalSize } from '../modal/Modal';

interface Props {
  isOpen: boolean;
  titleText?: string;
  contentText?: string | JSX.Element;
  onCancel?: () => void;
  onConfirm?: () => void;
  cancelText?: string;
  confirmText?: string;
  size?: ModalSize;
  height?: number;
}

const ConfirmModal: React.FC<Props> = ({
  isOpen = false,
  height,
  titleText,
  contentText,
  onCancel,
  onConfirm,
  children,
  cancelText,
  confirmText,
  size
}) => {
  const { t } = useTranslation();

  const title = <h3 className="modal-title">{titleText}</h3>;

  const buttons = (
    <div className="create-booking-modal__buttons">
      <Button buttonTypes={['blue-outline']} onClick={onCancel}>
        {cancelText || t('common.cancel')}
      </Button>
      <Button buttonTypes={['blue']} onClick={onConfirm}>
        {confirmText || t('common.confirm')}
      </Button>
    </div>
  );
  return (
    <Modal
      size={size}
      height={height}
      isOpen={isOpen}
      closeModal={() => {
        if (onCancel) {
          onCancel();
        }
      }}
      title={title}
      toolbar={buttons}
    >
      {contentText && <div className="modal__text">{contentText}</div>}
      {children}
    </Modal>
  );
};

export default ConfirmModal;
